module.exports = __webpack_public_path__ + "657ac992432e7e42f5af1a73ca6007b5.png";